export const NOTIFICATION_TYPE = {
	msg_notify: "MESSAGE_NOTIFY",
	messages: "MESSAGES",
	looks_vote: "LOOKS_VOTE",
	mutual_vote: "MUTUAL_VOTE",
	mutual_likes: "MUTUAL_LIKES",
	mutual_match: "MUTUAL_MATCH",
	ratings: "RATINGS",
};



// WEBPACK FOOTER //
// ./src/apps/notifications_footer/util/constants.js